<template>
  <div id="header">
    <!-- <h1>Higher or Lower <span> for Spotify Streams </span></h1>
    <p>Created By Aidan Goodyer</p> -->

    <img id="thelogo" src="../src/assets/hilow.svg"  alt="1111" />

    <div id="info">
      <button  >

        <div id="img-wrap" style="position:relative; ">
              <img  id="info-icon" @click="info=!info; " src="../src/assets/status/info.svg" :style=" info ? ' ' : '' " alt="info">
                <info-box :enabled="info" />
        </div>
          
          
      </button>
     
    </div>
   
  </div>
  <div class="horizontal" id="game-area" @click="this.info=false">
    <transition-group name="fade">
      <li v-for="artist in artists" :key="artist.id">
        <artist-item
          :isRevealed="this.artists.indexOf(artist) == 0"
          :artist="artist"
          @revealed="
            (choice) => {
              gameFunction(choice, artist.id);
            }
          "
        ></artist-item>
      </li>
    </transition-group>
    <status :theMode="this.result" />
    
  </div>

    <div id="footer">
     
     <div id="creator">2022 Aidan Goodyer</div>

      <div style="display:flex; align-items:center; justify-content:center; ">
          <h3 style="margin: 0; ">Score: {{ score }}</h3>
      </div>
 

 <div id="links">
 <a href="https://github.com/agoodyer"><img src="../src/assets/links/git.png" alt="github"></a>
 <a href="https://www.linkedin.com/in/aidan-goodyer/">
 <img src="../src/assets/links/in.png" alt="linkedin">
</a>
 </div>

    </div>
 

  <!-- <div id="load">
       <img  v-if="loading" src="https://upload.wikimedia.org/wikipedia/commons/d/de/Ajax-loader.gif" alt="">
  </div> -->
 
  <!-- <status :theMode="this.result" /> -->
  <modal
    :score="this.score"
    :enabled="this.result === 'cross'"
    @play="
      this.result = 'or';
      restart();
    "
  />

 
</template>

<script>
import ArtistItem from "./components/ArtistItem.vue";
import Status from "./components/Status.vue";
import Modal from "./components/Modal.vue";
import InfoBox from './components/InfoBox.vue'; 

export default {
  name: "App",
  components: {
    ArtistItem,
    Status,
    Modal,
    InfoBox
  },

  data() {
    return {
      score: 0,
      result: "or",
      loading: true,
      info:false,  
      artistKeys: [
        "3TVXtAsR1Inumwj472S9r4",
        "7tYKF4w9nC0nq9CsPZTHyP",
        "06HL4z0CvFAxyc27GXpf02",
        "1URnnhqYAYcrqrcwql10ft",
        "1Xyo4u8uXC1ZmMpatF05PJ",
        "0iEtIxbK0KxaSlF7G42ZOp",
        "1GxkXlMwML1oSg5eLPiAz3",
        "7dGJo4pcD2V6oG8kP0tJRR",
        "1RyvyyTE3xzB2ZywiAwp0i",
        "5K4W6rqBFWDnAN6FQUkS6x",
        "4oUHIQIBe0LHzYfvXNW4QM",
        "6ZjFtWeHP9XN7FeKSUe80S",
        "1uNFoZAHBGtllmzznpCI3s",
        "0Y5tJX1MQlPlqiwlOH1tJY",
        "66CXWjxzNUsdJxJ2JdwvnR",
        "4MCBfE4596Uoi2O4DtmEMz",
        "5f7VJjfbwm532GiveGC0ZK",
        "4iHNK0tOyZPYnBU7nGAgpQ",
        "1Mxqyy3pSjf8kZZL4QVxS0",
        "6eUKZXaKkcviH0Ku9w2n3V",
        "31W5EY0aAly4Qieq6OFu6I",
        "2YZyLoL8N0Wb9xBt1NhZWg",
        "7v4imS0moSyGdXyLgVTIV7",
        "246dkjvS1zLTtiykXe5h60",
        "1VPmR4DJC1PlOtd0IADAO0",
        "5pKCCKE2ajJHZ9KAiaK11H",
        "718COspgdWOnwOFpJHRZHS",
        "1Cs0zKBU1kc0i8ypK3B9ai",
        "7bXgB6jMjp9ATFy66eO08Z",
        "26AHtbjWKiwYzsoGoUZq53",
        "49e4v89VmlDcFCMyDv9wQ9",
        "40ZNYROS4zLfyyBSs2PGe2",
        "6qqNVTkY8uBg9cP3Jd7DAH",
        "2wY79sveU1sp5g7SokKOiI",
        "6l3HvQ5sa6mXTsMTB19rO5",
        "3BmGtnKgCSGYIUhmivXKWX",
        "15UsOTVnJzReFVN1VCnxy4",
        "6KImCVD70vtIoJWnq6nGn3",
        "4q3ewBCX7sLwd24euuV69X",
        "6AgTAQt8XS6jRWi4sX7w49",
        "00FQb4jTyendYWaN8pK0wa",
        "5WUlDfRSoLAfcVSX1WnrxN",
        "5cj0lLjcoR7YOSnhnX0Po5",
        "4O15NlyKLIASxsJ0PrXPfz",
        "4cPHsZM98sKzmV26wlwD2W",
        "3PhoLpVuITZKcymswpck5b",
        "43ZHCT0cAZBISjO8DG9PnE",
        "3hcs9uc56yIGFCSy9leWe7",
        "53XhwfbYqKCa1cC15pYq2q",
        "3Nrfpe0tUJi4K4DXYWgMUX",
        "1HY2Jd0NmPuamShAr6KMms",
        "0eDvMgVFoNV3TpwtrVCoTj",
        "2hlmm7s2ICUX0LVIhVFlZQ",
        "6LuN9FCkKOj5PcnpouEgny",
        "0MHgLfmQdutffmvWe5XBTN",
        "2jku7tDXc6XoB6MO2hFuqg",
        "4sj6D0zlMOl25nprDJBiU9",
        "4gzpq5DPGxSnKTe4SA8HAU",
        "6JL8zeS1NmiOftqZTRgdTz",
        "4LLpKhyESsyAXpc4laK94U",
        "0du5cEVh5yTK9QJze8zA0C",
        "50co4Is1HCEo8bhOyUWKpn",
        "4ytkhMSAnrDP8XzRNlw9FS",
        "4V8LLVI7PbaPR0K2TGSxFF",
        "6M2wZ9GZgrQXHCFfjv46we",
        "5H4yInM5zmHqpKIoMNAx4r",
        "6vWDO969PvNqNYHIOW5v0m",
        "0hCNtLu0JehylgoiP8L4Gh",
        "3MZsBdqDrRTJihTHQrO6Dq",
        "6jJ0s89eD6GaHleKKya26X",
        "2o5jDhtHVPhrJdv3cEQ99Z",
        "64KEffDW9EtZ1y2vBYgq8T",
        "5V0MlUE1Bft0mbLlND7FJz",
        "6jGMq4yGs7aQzuGsMgVgZR",
        "2h93pZq0e7k5yf4dywlkpM",
        "57vWImR43h4CaDao012Ofp",
        "7wlFDEWiM5OoIAt8RSli8b",
        "46SHBwWsqBkxI7EeeBEQG7",
        "38EmEgXkgK51MT2tPY0EoC",
        "5Pwc4xIPtQLFEnJriah9YJ",
        "7Ln80lUS6He07XvHI8qqHH",
        "2ye2Wgw4gimLv2eAKyk1NB",
        "5lpH0xAS4fVfLkACg9DAuM",
        "1dfeR4HaWDbWqFHLkxsg1d",
        "2LIk90788K0zvyj2JJVwkJ",
        "04gDigrS5kc9YWfZHwBETP",
        "77SW9BnxLY8rJ0RciFqkHh",
        "699OTQXzgjhIYAHMy9RyPD",
        "7n2wHs1TKAczGzO7Dd2rGr",
        "5y2Xq6xcjJb2jVM54GHK3t",
        "3qiHUAX7zY4Qnjx8TNUzVx",
        "2kCcBybjl3SAtIcwdWpUe3",
        "3WrFJ7ztbogyGnTHbHJFl2",
        "5v8jlSmAQfrkTjAlpUfWtu",
        "64M6ah0SkkRsnPGtGiRAbb",
        "4dpARuHxo51G3z768sgnrY",
        "26dSoYclwsYLMAKD3tpOr4",
        "3oSJ7TBVCWMDMiYjXNiCKE",
        "3tlXnStJ1fFhdScmQeLpuG",
        "26VFTg2z8YR0cCuwLzESi2",
        "0C8ZW7ezQVs4URX5aX7Kqx",
        "3nFkdlSjzX9mRTtwJOzDYB",
        "55Aa2cqylxrFIXC767Z865",
        "7CajNmpbOovFoOoasH2HaY",
        "4YLtscXsxbVgi031ovDDdh",
        "0TnOYISbd1XYRBk9myaseg",
        "2tIP7SsRs7vjIcLrU85W8J",
        "13ubrt8QOOCPljQ2FL1Kca",
        "3q7HBObVc0L8jNeTe5Gofh",
        "6XyY86QOPPrYVGvF9ch6wz",
        "5SXuuuRpukkTvsLuUknva1",
        "6deZN1bslXzeGvOLaLMOIF",
        "6Xgp2XMz1fhVYe7i6yNAax",
        "0fA0VVWsXO9YnASrzqfmYu",
        "6EPlBSH2RSiettczlz7ihV",
        "757aE44tKEUQEqRuT6GnEB",
        "3mIj9lX2MWuHmhNCA7LSCW",
        "4Gso3d4CscCijv0lmajZWs",
        "45dkTj5sMRSjrmBSBeiHym",
        "6TIYQ3jFPwQSRmorSezPxX",
        "7CyeXFnOrfC1N6z4naIpgo",
        "711MCceyCBcFnzjGY4Q7Un",
        "57LYzLEk2LcFghVwuWbcuS",
        "4fxd5Ee7UefO4CUXgwJ7IP",
        "3wcj11K77LjEY1PkEazffa",
        "08GQAI4eElDnROBrJRGE0X",
        "7jVv8c5Fj3E9VhNjxT4snq",
        "1McMsnEElThX1knmY4oliG",
        "4AK6F7OLvEQ5QYCBNiQWHq",
        "0ECwFtbIWEVNwjlrfc6xoL",
        "1vyhD5VmyZ7KMfW5gqLgo5",
        "4Ga1P7PMIsmqEZqhYZQgDo",
        "7K78lVZ8XzkjfRSI7570FF",
        "0L8ExT028jH3ddEcZwqJJ5",
        "3oDbviiivRWhXwIE8hxkVV",
        "4GNC7GD6oZMSxPGyXy4MNB",
        "4nDoRrQiYLoBzwC5BhVJzF",
        "0ErzCpIMyLcjPiwT4elrtZ",
        "4r63FhuTkUYltbVAg5TQnk",
        "16oZKvXb6WkQlVAjwo2Wbg",
        "391oLRVmoTkumiN79HkTWu",
        "3Xt3RrJMFv5SZkCfUE8C1J",
        "3win9vGIxFfBRag9S63wwf",
        "6fOMl44jA4Sp5b9PpYCkzz",
        "4kYSro6naA4h99UJvo89HB",
        "4npEfmQ6YuiwW1GpUmaq3F",
        "5ixB75BQR3ADoWQkcHQJTs",
        "2HPaUgqeutzr3jx5a9WyDV",
        "1ZwdS5xdxEREPySFridCfh",
        "1yxSLGMDHlW21z4YXirZDS",
        "0qSX3s5pJnAlSsgsCne8Cz",
        "7guDJrEfX3qb6FEbdPA5qi",
        "0QHgL1lAIqAw0HtD7YldmP",
        "6olE6TJLqED3rqDCT0FyPh",
        "4PULA4EFzYTrxYvOVlwpiQ",
        "6TLwD7HPWuiOzvXEa3oCNe",
        "2EMAnMvWE2eb56ToJVfCWs",
        "3eqjTLE0HfPfh78zjh6TqT",
        "1QAJqy2dA3ihHBFIHRphZj",
        "2iE18Oxc8YSumAU232n4rW",
        "73sIBHcqh3Z3NyqHKZ7FOL",
        "3fMbdgg4jU18AjLCKBhRSm",
        "4yiQZ8tQPux8cPriYMWUFP",
        "0BvkDsjIUla7X0k6CSWh1I",
        "69GGBxA162lTqCwzJG5jLp",
        "1KCSPY1glIKqW2TotWuXOR",
        "3IYUhFvPQItj6xySrBmZkd",
        "164Uj4eKjl6zTBKfJLFKKK",
        "32vWCbZh0xZ4o9gkz4PsEU",
        "41MozSoPIsD1dJM0CLPjZF",
        "3b8QkneNDz4JHKKKlLgYZg",
        "2RQXRUsr4IW1f3mKyKsy4B",
        "1z7b1Pr1rSlvWRzsW3HOrS",
        "0EmeFodog0BfCgMzAIvKQp",
        "5YGY8feqx7naU7z4HrwZM6",
        "54R6Y0I7jGUCveDTtI21nb",
        "6QtgPSJPSzcnn7dPZ4VINp",
        "0k17h0D3J5VfsdmQ1iZtE9",
        "4Uc8Dsxct0oMqx0P6i60ea",
        "2FXC3k01G6Gw61bmprjgqS",
        "7gOdHgIoIKoe4i9Tta6qdD",
        "2dIgFjalVxs4ThymZ67YCE",
        "5LHRHt1k9lMyONurDHEdrp",
        "5me0Irg2ANcsgc93uaYrpb",
        "46pWGuE3dSwY3bMMXGBvVS",
        "3Sz7ZnJQBIHsXLUSo0OQtM",
        "4VMYDCV2IEDYJArk749S6m",
        "2cFrymmkijnjDg9SS92EPM",
        "13ZEDW6vyBF12HYcZRr4EV",
        "5rSXSAkZ67PYJSvpUpkOr7",
        "5y8tKLUfMvliMe8IKamR32",
        "6x2LnllRG5uGarZMsD4iO8",
        "6VuMaDnrHyPL1p4EHjYLi7",
        "5KKpBU5eC2tJDzf0wmlRp2",
        "7oPftvlwr6VrsViSDV7fJY",
        "23fqKkggKUBHNkbKtXEls4",
        "4STHEaNw4mPZ2tzheohgXB",
        "7rkW85dBwwrJtlHRDkJDAC",
        "4mxWe1mtYIYfP040G38yvS",
        "4S9EykWXhStSc15wEx8QFK",
      ],

      artistData: [],

      artists: [],
    };
  },

  methods: {
    gameFunction(choice, key) {
      this.info=false; 
      this.artistData = this.artistData.filter((item) => item.id != key);

      setTimeout(() => {
        const selection = choice.selection;

        if (selection === "hi") {
          if (this.artists[1].followers > this.artists[0].followers) {
            this.score++;
            this.result = "check";
          } else {
            this.result = "cross";
          }
        }

        if (selection === "lo") {
          if (this.artists[1].followers < this.artists[0].followers) {
            this.score++;
            this.result = "check";
          } else {
            this.result = "cross";
          }
        }
      }, 1500);

      setTimeout(() => {
        if (this.result != "cross") {
          this.result = "or";

          this.artists.push(
            this.artistData[Math.floor(Math.random() * this.artistData.length)]
          );
          this.artists.shift();
        }
      }, 3000);
    },

    restart() {
      this.artists = [];

      setTimeout(() => {
        this.score = 0;
        this.artists.push(
          this.artistData[Math.floor(Math.random() * this.artistData.length)]
        );
        this.artists.push(
          this.artistData[Math.floor(Math.random() * this.artistData.length)]
        );
      }, 1000);
    },

    async getToken() {
      const clientId = "d8245d16980c4aaca5ef62a830288ba5";
      const clientSecret = "244c2d54a4d248a5aaa98a16d2a52160";

      const result = await fetch("https://accounts.spotify.com/api/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Basic " + btoa(clientId + ":" + clientSecret),
        },

        body: "grant_type=client_credentials",
      });

      const res = await result.json();
      return res.access_token;
    },

    async getArtist(token, artistId) {
      const response = await fetch(
        `https://api.spotify.com/v1/artists/${artistId}`,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );

      const data = await response.json();

      return {
        id: artistId,
        name: data.name,
        followers: data.followers.total,
        image: data.images[0].url,
      };
    },

    async loadArtists() {
      const token = await this.getToken();

      const test = await this.getArtistsPlural(token,0,49);
      const test2 = await this.getArtistsPlural(token,50,99);
      const test3 = await this.getArtistsPlural(token,100,149);
      const test4 = await this.getArtistsPlural(token,150,199);

      //DEPRECATED
      // for (var i = 0; i < this.artistKeys.length; i++) {
      //   const data = await this.getArtist(token, this.artistKeys[i]);
      //   this.artistData.push(data);
      // }

      this.artists.push(
        this.artistData[Math.floor(Math.random() * this.artistData.length)]
      );

       this.artistData = this.artistData.filter((item) => item.id != this.artistData[0].id );
      this.artists.push(
        this.artistData[Math.floor(Math.random() * this.artistData.length)]
      );

       this.artistData = this.artistData.filter((item) => item.id != this.artistData[1].id );

      this.loading=false;
     // console.log(this.artistData);
    },

    async getArtistsPlural(token, start,end ) {
      //Create the string used in the request
      var reqString = "";

    

      for( var i=start; i<=end;i++){
          reqString += this.artistKeys[i] + "%2C";
      }
      //remove trailing comma
      reqString = reqString.substring(0, reqString.length - 3);

      //Send the api request
      const response = await fetch(
        `https://api.spotify.com/v1/artists?ids=${reqString}`,
        {
          method: "GET",
          // mode: "no-cors",
          headers: { Authorization: "Bearer " + token },
        }
      );

      const data = await response.json();

      for (const i in data.artists) {
        const artist = {
          id: data.artists[i].id,
          name: data.artists[i].name,
          followers: data.artists[i].followers.total,
          image: data.artists[i].images[0].url,
        };

       
       // console.log(artist);

        this.artistData.push(artist);
      }
    },
  },

  mounted() {
    this.loadArtists();
    console.log(this.artistData);
  },

  computed: {},
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

#app {
  font-family: poppins;
  /* font-weight: 900; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}

#header h1 {
  font-weight: 800;
  text-align: left;
  padding-inline: 3em;
  padding-block: 0;
  margin-bottom: 0;
}

#header span {
  font-size: 0.6em;
  padding-inline: 0.5em;
}

#header p {
  text-align: left;
  padding-inline: 6.7em;
  font-size: 0.9em;
  margin-block: 0;
}

#header {
  /* padding-bottom: 2em; */
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

#header img {
  /* padding: 1.5em; */
  margin-inline: 3em;
  margin-top: 2em;
  overflow: hidden;
}


#thelogo{
   margin-inline: 3em;
  margin-top: 2em;
  height: 50px;
}
#img-wrap img{
  width:30px; position:relative; z-index:5000; 
}

#info button{
    
  border:none; 
  background:none; 
 
  width: fit-content;
  height: fit-content;
}

#info-icon {
  position: relative;
  z-index: 15200;
 transition: all 0.5s ease; 
}

#info-icon:hover{
  transform: scale(115%);
}

#footer{
  /* position: fixed;  */
  /* bottom: 10px; */
  overflow: hidden;
  background-color: #ffffff;
 
  /* padding-inline:2em; */
  width:100%;  
  display: grid;
  align-items: center;
  text-align: center;

  grid-template-columns: 1fr 1fr 1fr ;
 
 
}

#links{

    padding:0; 
  margin:0; 

  margin-left:auto; 
  display: flex;
 justify-self: left;
 padding-inline: 2em;
 flex-wrap: nowrap;


  
}

#footer img{
    padding:0; 
  margin:0; 
}

#links img {
  filter:contrast(0%) opacity(30%); 
  transition: all 0.5s ease ;
  height:25px; 
  padding-inline:0.5em; 
 
}

#links img:hover{
  filter:none; 

}


#creator{
  font-family: monospace;
  font-weight: 800;
  text-align: left;
  padding-inline: 2em;
  color: #d9d9d9;
}


#game-area {
  position: relative;
  overflow: hidden;
  /* min-height: min(580px, 78vmin); */
  /* min-width: 400px; */

min-height: calc(580px + 2em );
 
}

.bubble {
  background-color: #1db954;
  padding: 1.3em;
  border-radius: 30em;
  font-weight: 900;
  font-size: 1.5em;
  /* color:#191414;  */
  color: #ffffff;
}

li {
  list-style: none;
}

.horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

#load{
  position: absolute;
  top:50%; 
  left: 50%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateX(-50%);
}

@media (max-aspect-ratio: 5/6) {
  .horizontal {
    flex-direction: column;
  }

  /* #header {
    display: none;
  } */

 
 



  #info{
    margin-left: auto;
  }


   #thelogo {
    margin:0; 
    height:30px; 

  }

  .fade-enter-from {
    transform: translate(0, 800px);
  }

  .fade-leave-to {
    transform: translate(0, -800px);
  }
}

.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: all 1.2s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-enter-from {
  opacity: 0;
  transform: translate(800px, 0);
}

.fade-leave-to {
  opacity: 0;
  transform: translate(-800px, 0);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
.fade-leave-active {
  position: absolute;
}
</style>
